import React from 'react'
import { Logo as LogoImage } from '@/app/images'

export const Logo = () => {
	return <img src={LogoImage} alt="enbek" />
}
